import React from 'react';
import { Download, Loader2, XCircle } from 'lucide-react';

interface VideoExportButtonProps {
  onExport: () => void;
  progress: number;
  isExporting: boolean;
  error: string | null;
}

const VideoExportButton: React.FC<VideoExportButtonProps> = ({
  onExport,
  progress,
  isExporting,
  error,
}) => {
  return (
    <div className="space-y-2">
      <button
        onClick={onExport}
        disabled={isExporting}
        className={`w-full font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2 ${
          isExporting
            ? 'bg-gray-400 cursor-not-allowed text-white'
            : 'bg-green-600 hover:bg-green-700 text-white'
        }`}
      >
        {isExporting ? (
          <>
            <Loader2 className="w-5 h-5 animate-spin" />
            エクスポート中... {progress}%
          </>
        ) : (
          <>
            <Download className="w-5 h-5" />
            動画をダウンロード
          </>
        )}
      </button>

      {isExporting && (
        <div className="w-full bg-gray-200 rounded-full h-2">
          <div
            className="bg-green-600 h-2 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>
      )}

      {error && (
        <div className="flex items-start gap-2 p-3 bg-red-50 border border-red-200 rounded-lg">
          <XCircle className="w-4 h-4 text-red-500 mt-0.5 flex-shrink-0" />
          <p className="text-sm text-red-700">{error}</p>
        </div>
      )}
    </div>
  );
};

export default VideoExportButton;
